<template>
  <div class="paymentothers">
    <div class="orderlink">
      订单链接：
      <p>{{ orderlink }}</p>
      <el-button
        v-clipboard:copy="orderlink"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        >复制</el-button
      >
    </div>
    <p class="tishimsg">
      <i class="el-icon-warning-outline"></i
      >复制订单链接发给朋友代付（微信打开链接）
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderlink: "123xcv456xcvxbn789sdvcfbgcsbn3456xcvcvb"
    };
  },
  methods: {
    onCopy() {
      this.$message({
        message: "复制成功！",
        type: "success"
      });
    },
    onError() {
      this.$message.error("复制失败！");
    }
  }
};
</script>

<style lang="scss">
.paymentothers {
  width: 100%;
  .orderlink {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 17px;
    p {
      width: 376px;
      padding: 7px;
      border: 1px solid #dadada;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
      margin-right: 11px;
    }
    .el-button {
      width: 63px;
      height: 32px;
      border: 1px solid rgba(48, 113, 254, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(48, 113, 254, 1);
      line-height: 20px;
      padding: 0;
      background: #fff;
      border-radius: 0;
    }
  }
  .tishimsg {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 17px;
    margin-top: 11px;
    i {
      color: #3071fe;
      margin-right: 7px;
    }
  }
}
</style>
